import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import debounce from 'lodash/debounce';

gsap.registerPlugin(ScrollTrigger);

const desktopBreakpoint = window.matchMedia('(min-width: 768px)');
const section = document.getElementById('capacity');
const intro = section.querySelector('.capacity__intro');
const introLine = section.querySelector('.capacity__intro__line');
const models = document.querySelectorAll('.capacity__model');
const tabs = document.querySelectorAll('.capacity__tab');

/**
 * Count-up animations.
 */
Array.from(models).forEach((model) => {
  // Floating label.
  const floatingLabels = model.querySelector('.capacity__model__floating-labels');

  // Height.
  const heightValueElement = model.querySelector('.capacity__model__height__value__value');
  const heightRawValue = {
    value: heightValueElement.getAttribute('data-raw-value'),
  };
  const heightHasDecimal = heightRawValue.value.indexOf('.') > -1;

  // Capacity.
  const capacityValueElement = model.querySelector('.capacity__model__capacity__value__value');
  const capacityRawValue = {
    value: capacityValueElement.getAttribute('data-raw-value'),
  };

  gsap.set(floatingLabels, {
    autoAlpha: 0,
    y: '+=50',
  });
  ScrollTrigger.create({
    trigger: section,
    start: 'top center',
    once: true,
    onEnter() {
      gsap.timeline()
        // Floating label.
        .fromTo(floatingLabels, {
          autoAlpha: 0,
          y: '+=50',
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 1,
        })
        // Height.
        .fromTo(heightRawValue, {
          value: heightHasDecimal ? 0.0 : 0,
        }, {
          value: heightRawValue.value,
          duration: 3,
          snap: {
            value: heightHasDecimal ? 0.5 : 1,
          },
          onUpdate() {
            const { value } = this.targets()[0];
            heightValueElement.innerHTML = heightHasDecimal ? parseFloat(value).toFixed(1) : value;
          },
        }, '<')
        // Capacity.
        .fromTo(capacityRawValue, {
          value: 0,
        }, {
          value: capacityRawValue.value,
          duration: 3,
          snap: {
            value: 100,
          },
          onUpdate() {
            const { value } = this.targets()[0];
            const formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            capacityValueElement.innerHTML = formattedValue;
          },
        }, '<');
    },
  });
});

/**
 * Intro animation.
 */
ScrollTrigger.create({
  trigger: section,
  onEnter() {
    gsap.timeline()
      .from(intro, {
        autoAlpha: 0,
        y: '+=100',
        duration: 1.0,
      })
      .from(introLine, {
        scaleY: 0,
      }, '<+0.5');
  },
});

const setActiveItem = (index = 1) => {
  // Set active tab.
  Array.from(models).forEach((model) => {
    const modelIndex = parseInt(model.getAttribute('data-index'), 10);
    if (index === modelIndex) {
      model.classList.add('capacity__model--active');
    } else {
      model.classList.remove('capacity__model--active');
    }
  });

  // Set active model.
  Array.from(tabs).forEach((tab) => {
    const tabIndex = parseInt(tab.getAttribute('data-index'), 10);
    if (index === tabIndex) {
      tab.classList.add('capacity__tab--active');
    } else {
      tab.classList.remove('capacity__tab--active');
    }
  });
};

// Reset active models/tabs on desktop.
window.addEventListener('resize', debounce(() => {
  setActiveItem(models.length);
}, 100));

// Tabs click events.
Array.from(tabs).forEach((tab) => {
  tab.addEventListener('click', (e) => {
    e.preventDefault();
    const index = parseInt(tab.getAttribute('data-index'), 10);
    setActiveItem(index);
  });
});
